import React, { useRef, useEffect } from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import { DateTime } from 'luxon';
import { AIRQUALITY_CHART_COLORS, X_AXIS_LABEL_FORMAT, AIRQUALITY_TMA_CHART_COLOR } from './config';
export const AirQualityLineGraph = ({ translationData, data, metric, xAxisLabels, isExport, fileName, showTma, optimumTma, tmaMetric, imageWidth, imageHeight }) => {
    const xLabels = xAxisLabels && xAxisLabels.map(each => DateTime.fromISO(each).toFormat(X_AXIS_LABEL_FORMAT));
    const seriesData = [];
    data.forEach(item => {
        seriesData.push({
            name: item.name,
            data: item.rows,
            marker: false,
            clip: false,
        });
    });
    if (showTma) {
        seriesData.push({
            name: translationData.tmaSeriesName,
            data: xAxisLabels && xAxisLabels.map(each => optimumTma),
            marker: false,
            clip: false,
            color: AIRQUALITY_TMA_CHART_COLOR,
            tooltip: {
                valueSuffix: ` ${tmaMetric}`,
            },
        });
    }
    const chartRef = useRef(null);
    const chartOptions = {
        title: {
            text: '',
        },
        series: seriesData,
        exporting: {
            enabled: false,
            filename: fileName,
            sourceWidth: imageWidth,
            sourceHeight: imageHeight,
        },
        xAxis: {
            categories: xLabels,
        },
        colors: AIRQUALITY_CHART_COLORS,
        yAxis: {
            title: {
                text: translationData.yAxisTitle,
            },
            allowDecimals: false,
        },
        tooltip: {
            valueSuffix: ` ${metric}`,
            pointFormat: '{series.name}: <b>{point.y}</b><br/>'
        },
        legend: {
            align: 'center',
            verticalAlign: 'top',
            layout: 'horizontal',
        },
        credits: {
            enabled: false,
        },
    };
    const exportChart = () => {
        // @ts-ignore
        chartRef.current.chart.exportChart();
    };
    useEffect(() => {
        if (isExport) {
            exportChart();
        }
    }, [isExport]);
    return (React.createElement(HighchartsReact, { containerProps: { style: { height: "100%" } }, highcharts: Exporting(Highcharts), constructorType: 'chart', options: chartOptions, ref: chartRef }));
};
//# sourceMappingURL=AirQualityLineGraph.js.map